export default "__VITE_PUBLIC_ASSET__98044ad9__"